

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const createproductloanreceipt = {
    label: "Create Product Loan Receipt",
    pageLabel: "Create Product Loan Receipt",
    starting: true,
    url: "createproductloanreceipt",
    pageType: "history",
       
    form: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product ",
            name: "",
            description: "Enter Product "
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Product",
            name: "Product",
            description: "Product"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "GeneralLedge ",
            name: "",
            description: "Enter GeneralLedge "
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "GeneralLedge",
            name: "GeneralLedge",
            description: "GeneralLedge"
          },
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Amount Type Flag",
            name: "",
            description: "Amount Type Flag"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Saction Amount",
                value: "Saction_Amount"
              },
              {
                label: "Security Gross Amount",
                value: "Security_Gross_Amount"
              },
             ],
            placeHolder: "Amount Type Flag",
            name: "Amount_Type_Flag",
            description: "Enter Amount Type Flag"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Amount Flag",
            name: "",
            description: "Enter Amount Flag"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Fixed Amount",
                value: "FixedAmount"
              },
              {
                label: "Percentage",
                value: "Percentage"
              },
              {
                label: "Amount Range",
                value: "AmountRange"
              }
             ],
            placeHolder: "Amount Flag",
            name: "Amount_Flag",
            description: "Enter Amount Flag"
          },
          
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Amount",
            name: "",
            description: "EnterAmount"
          },
          {
            inputType: "text",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Amount",
            name: "Amount",
            description: "Enter Amount"
          },
          
    ]
}

export default createproductloanreceipt;